import { render, staticRenderFns } from "./WithdrawalDetail.vue?vue&type=template&id=0559cd5e&scoped=true&"
import script from "./WithdrawalDetail.vue?vue&type=script&lang=js&"
export * from "./WithdrawalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0559cd5e",
  null
  
)

export default component.exports